let ErpRoutes = [
  // 资料管理
  {
    path: '6701',
    name: '6701', // 仓库维护
    component: () => import('@/pages/ErpManage/info/storehouse/index')
  },
  {
    path: '6702',
    name: '6702', // 商品品牌
    component: () => import('@/pages/ErpManage/info/brand/index')
  },
  {
    path: '6703',
    name: '6703', // 商品类别
    component: () => import('@/pages/ErpManage/info/category/index')
  },
  {
    path: '6704',
    name: '6704', // 计量单位
    component: () => import('@/pages/ErpManage/info/unit/index')
  },
  {
    path: '6705',
    name: '6705', // 供应商
    component: () => import('@/pages/ErpManage/info/supplier/index')
  },
  {
    path: '6706',
    name: '6706', // 商品信息
    component: () => import('@/pages/ErpManage/info/goods/index')
  },
  // 采购入库
  {
    path: '6802',
    name: '6802',
    component: () => import('@/pages/ErpManage/inStock/purchaseStock/index')
  },
  {
    path: 'goodPage',
    name: 'goodPage',
    component: () => import('@/pages/ErpManage/inStock/purchaseStock/good')
  },
  {
    path: 'paymentPage',
    name: 'paymentPage',
    component: () => import('@/pages/ErpManage/inStock/purchaseStock/payment')
  },
  // 入库管理
  {
    path: '6801',
    name: '6801', // 入库登记
    component: () => import('@/pages/ErpManage/inStock/inStock/index')
  },
  // 出库管理
  {
    path: '6901',
    name: '6901', // 供应商退货
    component: () => import('@/pages/ErpManage/outStock/supplier/index')
  },
  {
    path: '6902',
    name: '6902', // 手工出库
    component: () => import('@/pages/ErpManage/outStock/hand/index')
  },

  // 库存管理
  {
    path: '7001',
    name: '7001', // 商品库存
    component: () => import('@/pages/ErpManage/stock/good/index')
  },
  {
    path: '7002',
    name: '7002', // 报损
    component: () => import('@/pages/ErpManage/stock/frmLoss/index')
  },
  {
    path: '7003',
    name: '7003', // 盘点
    component: () => import('@/pages/ErpManage/stock/check/index')
  },
  // 销售管理
  {
    path: '7101',
    name: '7101', // 销售调价
    component: () => import('@/pages/ErpManage/sale/price/index')
  },
  {
    path: '7102',
    name: '7102', // 销售明细
    component: () => import('@/pages/ErpManage/sale/detail/index')
  },
  {
    path: '7103',
    name: '7103', // 销售汇总
    component: () => import('@/pages/ErpManage/sale/gather/index')
  },
  {
    path: '7104',
    name: '7104', // 销售退货
    component: () => import('@/pages/ErpManage/sale/refund/index')
  },
  {
    path: '7105',
    name: '7105', // 其他收入
    component: () => import('@/pages/ErpManage/sale/other/index')
  },
  {
    path: '7106',
    name: '7106', // 在途订单
    component: () => import('@/pages/ErpManage/sale/transitOrder/index')
  },
  // 汇总报表
  {
    path: '7201',
    name: '7201', // 出入库汇总
    component: () => import('@/pages/ErpManage/report/stock/index')
  },
  {
    path: '7202',
    name: '7202', // 营收汇总
    component: () => import('@/pages/ErpManage/report/revenue/index')
  },
  {
    path: '7203',
    name: '7203', // 渠道销售汇总
    component: () => import('@/pages/ErpManage/report/saleChanel/index')
  },
  {
    path: '7204',
    name: '7204', // 收银汇总
    component: () => import('@/pages/ErpManage/report/cashier/index')
  },
  {
    path: '7205',
    name: '7205', // 供应商供货汇总
    component: () => import('@/pages/ErpManage/report/supplierDelivery/index')
  },
  {
    path: '7206',
    name: '7206', // 供应商付款汇总
    component: () => import('@/pages/ErpManage/report/supplierPay/index')
  }
]

export {
  ErpRoutes
}



// WEBPACK FOOTER //
// ./src/router/ErpRoutes.js